import { Routes, Route, Navigate } from "react-router-dom";
import Menu from "../../pages/Menu";
import Login from "../../pages/Login";

// Legacy shell (rendered only for /menu, /login) — ระบบฝาก-ถอน/โปร/กงล้อ/เช็คอิน เดิม
// หน้าอื่น ๆ ทั้งหมดย้ายไป src/lotto/ (Midnight Lotto) แล้ว
const PageContent = () => (
  <Routes>
    <Route path="/login" element={<Login />} />
    <Route path="/menu" element={<Menu />} />
    <Route path="*" element={<Navigate to="/menu" replace />} />
  </Routes>
);

export default PageContent;
